import { render, staticRenderFns } from "./InsertMulti.vue?vue&type=template&id=2d7e2e50&scoped=true&"
import script from "./InsertMulti.vue?vue&type=script&lang=js&"
export * from "./InsertMulti.vue?vue&type=script&lang=js&"
import style0 from "./InsertMulti.vue?vue&type=style&index=0&id=2d7e2e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7e2e50",
  null
  
)

export default component.exports